module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "faq"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      FAQ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "alternating-divs col-12 row",
    attrs: {
      "id": "faq-content"
    }
  }, [_c('div', {
    staticClass: "col-12 white-block"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("Comment me préparer à l'intervention ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('ul', [_c('li', [_vm._v("Arriver "), _c('b', [_vm._v("reposé")]), _vm._v(" et en forme, bien dormir la veille")]), _vm._v(" "), _c('li', [_vm._v("Respecter la "), _c('b', [_vm._v("prescription pré-opératoire")])]), _vm._v(" "), _c('li', [_vm._v("Ne pas oublier de venir avec son "), _c('b', [_vm._v("dossier")]), _vm._v(" et ses "), _c('b', [_vm._v("examens radiologiques")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("N’hésitez pas")]), _vm._v(" à nous poser toutes vos questions ! Car la "), _c('b', [_vm._v("réussite du traitement")]), _vm._v(" est un "), _c('b', [_vm._v("traitement compris")]), _vm._v(" par le patient")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 skew-c"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 colour-block"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("Quelles sont les clés de la réussite du traitement ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('ul', [_c('div', {
    staticClass: "pt-2 pb-3"
  }, [_vm._v("Vous êtes l’"), _c('b', [_vm._v("acteur de votre traitement")]), _vm._v(". Voici les clés pour mettre toutes les chances de votre côté :")]), _vm._v(" "), _c('li', [_vm._v("Un "), _c('b', [_vm._v("détartrage récent")]), _vm._v(", un "), _c('b', [_vm._v("brossage")]), _vm._v(" rigoureux et régulier et une bonne hygiène de vie")]), _vm._v(" "), _c('li', [_vm._v("Une "), _c('b', [_vm._v("alimentation saine et équilibrée")]), _vm._v(" : prendre des compléments de vitamines C, D, Calcium, Magnésium et d’anti-oxydants si besoin car toute carence peut altérer voire empêcher une cicatrisation ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pas de tabac & alcool")]), _vm._v(" : il est conseillé de "), _c('b', [_vm._v("s'abstenir")]), _vm._v(" de boire et de fumer car ce sont des "), _c('b', [_vm._v("facteurs de risque d'échec")]), _vm._v(" de cicatrisation. "), _c('b', [_vm._v("N'hésitez pas")]), _vm._v(" à en parler avec votre chirurgien.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 skew-cc"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 white-block"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("Que dois-je faire après l’intervention ?")]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('ul', [_c('li', [_vm._v("Ne pas solliciter les zones opérées")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pas d’activité physique")]), _vm._v(" pendant 1 à 2 semaines selon la chirurgie")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Manger froid")]), _vm._v(" ou tiède, alimentation molle")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Éviter")]), _vm._v(" la consommation de "), _c('b', [_vm._v("tabac")]), _vm._v(" et "), _c('b', [_vm._v("alcool")])]), _vm._v(" "), _c('li', [_vm._v("Des "), _c('b', [_vm._v("sensibilités post-opératoires")]), _vm._v(" peuvent apparaître. Une "), _c('b', [_vm._v("ordonnance")]), _vm._v(" vous sera délivrée avant l'intervention afin que vos suites post-opératoires soient les plus "), _c('b', [_vm._v("agréables")]), _vm._v(" possibles.")]), _vm._v(" "), _c('li', [_vm._v("Référez vous aux "), _c('b', [_vm._v("conseils post-opératoires remis")]), _vm._v(". Pour les télécharger,\n              "), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "static/Files/Info Conseils post-op.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n                cliquer ici\n              ")])])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-179892b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-179892b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/faq/faq.component.html
// module id = 261
// module chunks = 1